import React, { useEffect, useState } from "react";
import api from "../../services/api";
import toast from "react-hot-toast";
import { X, LayoutGrid, ToggleLeft, ToggleRight, Edit3, Trash2 } from 'lucide-react';
import '../../styles/SubComponentsAdmin.css';

const Categorias = ({ estabelecimentoId }) => {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editandoId, setEditandoId] = useState(null);

  const initialState = {
    nome: "",
    descricao: "",
    ordem: 0,
    ativo: 1
  };

  const [novaCategoria, setNovaCategoria] = useState(initialState);

  const carregarCategorias = async () => {
    if (!estabelecimentoId) return;
    try {
      const { data } = await api.get(`/cardapio/categorias/${estabelecimentoId}`);
      setCategorias(data);
    } catch (error) {
      toast.error("Erro ao carregar categorias");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarCategorias();
  }, [estabelecimentoId]);

  const abrirEdicao = (cat) => {
    setEditandoId(cat.id);
    setNovaCategoria({
      nome: cat.nome || "",
      descricao: cat.descricao || "",
      ordem: cat.ordem || 0,
      ativo: cat.ativo
    });
    setShowModal(true);
  };

  const fecharModal = () => {
    setShowModal(false);
    setEditandoId(null);
    setNovaCategoria(initialState);
  };

  const salvarCategoria = async (e) => {
    e.preventDefault();
    try {
      const dados = { ...novaCategoria, estabelecimento_id: estabelecimentoId };

      if (editandoId) {
        await api.put(`/cardapio/categorias/${editandoId}`, dados);
        toast.success("Categoria atualizada");
      } else {
        await api.post(`/cardapio/categorias`, dados);
        toast.success("Categoria criada");
      }

      fecharModal();
      carregarCategorias();
    } catch (error) {
      toast.error("Erro ao salvar categoria");
    }
  };

  const excluirCategoria = async (categoriaId) => {
    if (!window.confirm("Excluir esta categoria? Todos os produtos vinculados podem ficar sem seção.")) return;
    try {
      await api.delete(`/cardapio/categorias/${categoriaId}`);
      toast.success("Categoria removida");
      carregarCategorias();
    } catch (error) {
      toast.error("Erro ao excluir");
    }
  };

  const toggleStatus = async (cat) => {
    try {
      await api.put(`/cardapio/categorias/${cat.id}`, {
        ...cat,
        ativo: cat.ativo ? 0 : 1
      });
      toast.success(cat.ativo ? "Categoria pausada" : "Categoria ativada");
      carregarCategorias();
    } catch (error) {
      toast.error("Erro ao atualizar status");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNovaCategoria(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (loading) return <div className="loader-container"><div className="spinner"></div></div>;

  return (
    <div className="tab-content animate-fade-in">
      <div className="top-info" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: '25px' }}>
        <div>
          <h2 className="content-title" style={{ margin: 0 }}>Gestão de Categorias</h2>
          <p style={{ color: "#64748b", fontSize: '14px' }}>Organize seu cardápio em seções para facilitar a navegação do cliente.</p>
        </div>
        <button onClick={() => setShowModal(true)} className="btn-confirm">
          + Nova Categoria
        </button>
      </div>

      <div className="card" style={{ padding: 0, overflow: "hidden", borderRadius: '12px', border: '1px solid #e2e8f0' }}>
        <table className="custom-table">
          <thead>
            <tr>
              <th>Nome / Descrição</th>
              <th style={{ textAlign: 'center' }}>Ordem</th>
              <th style={{ textAlign: 'center' }}>Status</th>
              <th style={{ textAlign: 'right' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {categorias.map((cat) => (
              <tr key={cat.id}>
                <td style={{ padding: "15px" }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div className="cat-icon-box" style={{ background: '#f1f5f9', padding: '8px', borderRadius: '8px' }}>
                        <LayoutGrid size={18} color="#64748b" />
                    </div>
                    <div>
                        <strong style={{ display: 'block', color: '#1e293b', fontSize: '15px' }}>{cat.nome}</strong>
                        <small style={{ color: '#64748b' }}>{cat.descricao || "Sem descrição informada"}</small>
                    </div>
                  </div>
                </td>
                <td style={{ padding: "15px", textAlign: 'center', fontWeight: '600' }}>
                    {cat.ordem}º
                </td>
                <td style={{ padding: "15px", textAlign: 'center' }}>
                  <button 
                    onClick={() => toggleStatus(cat)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}
                    title={cat.ativo ? "Clique para desativar" : "Clique para ativar"}
                  >
                    {cat.ativo ? (
                        <span className="badge-active" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                           <ToggleRight size={18} /> ATIVO
                        </span>
                    ) : (
                        <span className="badge-inactive" style={{ display: 'flex', alignItems: 'center', gap: '5px', background: '#fee2e2', color: '#991b1b' }}>
                           <ToggleLeft size={18} /> INATIVO
                        </span>
                    )}
                  </button>
                </td>
                <td style={{ padding: "15px", textAlign: "right" }}>
                  <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button onClick={() => abrirEdicao(cat)} className="btn-edit-small" title="Editar">
                        <Edit3 size={18} />
                    </button>
                    <button onClick={() => excluirCategoria(cat.id)} className="btn-delete-small" title="Excluir">
                        <Trash2 size={18} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {categorias.length === 0 && (
          <div style={{ padding: '60px 20px', textAlign: 'center', color: '#94a3b8' }}>
            <LayoutGrid size={40} style={{ margin: '0 auto 15px', opacity: 0.3 }} />
            <p>Nenhuma categoria encontrada para este estabelecimento.</p>
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" style={{ zIndex: 2500 }}>
          <div className="modal" style={{ maxWidth: '500px', width: '95%' }}>
            <div className="modal-header-flex">
              <h2 style={{ margin: 0 }}>{editandoId ? "Editar Categoria" : "Nova Categoria"}</h2>
              <button onClick={fecharModal} className="btn-close-modal-x">
                <X size={24} />
              </button>
            </div>
            
            <form onSubmit={salvarCategoria} style={{ marginTop: '20px' }}>
              <label className="label">Nome da Categoria</label>
              <input
                className="input"
                name="nome"
                type="text"
                autoComplete="off"
                placeholder="Ex: Pizzas Salgadas, Bebidas, Combos..."
                value={novaCategoria.nome}
                onChange={handleChange}
                required
              />

              <label className="label">Descrição Curta</label>
              <textarea
                className="input"
                name="descricao"
                placeholder="Uma breve descrição da seção (ex: Pizzas artesanais de 35cm)"
                style={{ height: "80px", resize: 'none' }}
                value={novaCategoria.descricao}
                onChange={handleChange}
              />

              <div className="input-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                <div className="input-group">
                  <label className="label">Ordem (Posição)</label>
                  <input
                    type="number"
                    name="ordem"
                    className="input"
                    value={novaCategoria.ordem}
                    onChange={handleChange}
                  />
                </div>
                <div className="input-group">
                  <label className="label">Status Inicial</label>
                  <select
                    className="input"
                    name="ativo"
                    value={novaCategoria.ativo}
                    onChange={(e) => setNovaCategoria(prev => ({ ...prev, ativo: Number(e.target.value) }))}
                  >
                    <option value={1}>Ativo (Visível)</option>
                    <option value={0}>Inativo (Oculto)</option>
                  </select>
                </div>
              </div>

              <div className="modal-footer-btns" style={{ marginTop: '25px' }}>
                <button type="button" onClick={fecharModal} className="btn-cancel">Cancelar</button>
                <button type="submit" className="btn-save-confirm" style={{ flex: 1 }}>
                  {editandoId ? "Atualizar Categoria" : "Criar Categoria"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Categorias;